export default "__VITE_ASSET__C9TbS1Rd__"